import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { ReSelectModule } from '@common/re-select/re-select.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { GoogleAddressModule } from '@directive/google-address/google-address.module';
import { LibraryMenuModule } from '@modules/library/private/library-menu/library-menu.module';
import { LibraryViewModeModule } from '@modules/library/private/library-view-mode/library-view-mode.module';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { ListingPrimeNgModule } from '../../listing-primeNg.module';
import { AddPropertiesComponent } from './add-properties.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { PriceInputModule } from '@common/price-input/price-input.module';

@NgModule({
  declarations: [AddPropertiesComponent],
  imports: [
    FeatureFlagModule,
    CommonModule,
    ListingPrimeNgModule,
    CommonSharedModule,
    LibraryMenuModule,
    LibraryViewModeModule,
    GenaricNotesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ReorderPipeModule,
    ReMultiselectModule,
    ReSelectModule,
    GoogleAddressModule,
    HistoryModule,
    ReMultipleSelectModule,
    PriceInputModule,
  ],
  exports: [AddPropertiesComponent],
})
export class AddPropertyModule {}
